import { render, staticRenderFns } from "./VirtualKeyboardMagnetic.vue?vue&type=template&id=55c6d453&scoped=true&"
import script from "./VirtualKeyboardMagnetic.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboardMagnetic.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboardMagnetic.vue?vue&type=style&index=0&id=55c6d453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c6d453",
  null
  
)

export default component.exports